import { useEffect, useState, useCallback } from 'react';
import { lclClient } from '../api/lclClient';
import toast from 'react-hot-toast';

export function useLclSettings() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const refetch = useCallback(async () => {
    setLoading(true);
    try { setData(await lclClient.getSettings()); }
    catch (e) { toast.error(`Chargement settings: ${e.message}`); }
    finally { setLoading(false); }
  }, []);

  const save = useCallback(async (patch) => {
    try {
      const updated = await lclClient.updateSettings(patch);
      setData(updated);
      toast.success('Configuration enregistrée');
      return true;
    } catch (e) {
      toast.error(`Erreur: ${e.response?.data?.message || e.message}`);
      return false;
    }
  }, []);

  useEffect(() => { refetch(); }, [refetch]);
  return { data, loading, refetch, save };
}
